import styled, { css } from "styled-components"

const TextBlockStyles = styled.div`
	font-size: ${props => props.theme.font.size.base}!important;

	h1, h2, h3, h4 {
		font-family: ${props => props.theme.font.family.bold};
		font-weight: 400;
		margin: 1.5rem 0;
	}

	h3 {
		color: ${props => props.theme.colors.primary};
		font-size: ${props => props.theme.font.size.md};
	}

	p {
		margin-bottom: 2rem !important;
		&:last-child {
			margin: 0 !important;
		}
	}

	ol {
		list-style: none;
		padding: 0;
		counter-reset: my-awesome-counter;
		
		li {
			counter-increment: my-awesome-counter;
			padding-bottom: 1rem;
			
			&:last-child {
				padding-bottom: 0;
			}
			
			&:before {
				content: counter(my-awesome-counter) ". ";
				color: ${props => props.theme.colors.primary};
				font-family: ${props => props.theme.font.family.bold};
			}
		}
	}

	ul {
		padding-left: 0;
		list-style: none;
		
		li {
			padding-left: 20px;
			padding-bottom: 1rem;
			position: relative;
			a {
				text-decoration: none;
				color: ${props => props.theme.colors.primary};
				font-weight: 700;
				&:hover {
					color: ${props => props.theme.colors.tertiary};
				}
			}
			&:last-child {
				padding-bottom: 0;
			}
			
			&:before {
				content: "";
				position: absolute;
				height: 9px;
				width: 9px;
				border-radius: 50%;
				left: 0;
				top: .55rem;
				background-color: ${props => props.theme.colors.black};
			}
		}
	}
	${props => props.$heroText && css`
		font-size: 10px;
	`}
`

export default TextBlockStyles